import { render, staticRenderFns } from "./BulkOrderUpdate.vue?vue&type=template&id=92c4c8fa&scoped=true&"
import script from "./BulkOrderUpdate.vue?vue&type=script&lang=ts&"
export * from "./BulkOrderUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./BulkOrderUpdate.vue?vue&type=style&index=0&id=92c4c8fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c4c8fa",
  null
  
)

export default component.exports